const unavailableClientUrl = 'Application URL unavailable';

export const getOAuthClientHostname = (value: unknown) => {
  if (typeof value !== 'string' || !value.trim()) return unavailableClientUrl;

  try {
    const parsed = new URL(value.trim());
    if (!['http:', 'https:'].includes(parsed.protocol) || !parsed.hostname) {
      return unavailableClientUrl;
    }
    return parsed.hostname;
  } catch {
    return unavailableClientUrl;
  }
};
